<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Update Vehicle Rate</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <fieldset [disabled]="saving" class="min-w-0">
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Search Case Series</h2>
      <div class="w-full md:max-w-xl">
        <app-data-form
          [dataFields]="searchBooking"
          dataName="searchBooking"
          [columns]="1"
          (updateFields_child)="updateFields($event)"
          (clickSearch)="searchCaseSeries()"
        />
      </div>
    </section>
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Update Vehicle Rate</h2>
      <app-data-form
        [dataFields]="buyersDetails"
        dataName="buyersDetails"
        (updateFields_child)="updateFields($event)"
      />
      <div
        class="mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row"
      >
        <button
          class="shorter-btn misc-btn"
          [disabled]="!selectedRow || loading"
          (click)="updateVehicleRate()"
        >
          <fa-icon [icon]="faFloppyDisk" class="mr-1" />Update
        </button>
        <button
          class="shorter-btn clear-btn"
          (click)="clearVehicleRateForm()"
        >
          <fa-icon [icon]="faEraser" class="mr-1" />Clear
        </button>
      </div>
    </section>
    <p *ngIf="loading" class="my-4" role="status">
      Loading vehicle rates...
    </p>
    <p *ngIf="message" class="my-4" role="status">{{ message }}</p>
    <section class="content-container" *ngIf="filteredData.length">
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[52rem]"
          [tableHeaders]="tableHeaders"
          [tableEntries]="filteredData"
          [pagination]="false"
          (edit)="editVehicleRate($event)"
        />
      </div>
    </section>
  </fieldset>
</section>
